// The date line. Below zoom 2 the basemap's tiles (z0 and z1) cut the
// Pacific's water polygon at ±180 with no buffer beyond it, and the
// coastline layer (tol_coastline, packages/core/src/layers.ts) outlines
// every edge of every water ring, that cut included: a thin blue line down
// the Pacific, once per world copy. From zoom 2 the tiles overlap and the
// cut falls outside what's drawn. The coastline stays (it's what gives the
// continents their edge at world zoom); a line in the water's own color is
// drawn over the cut, where the date line crosses open sea.

import type { Map as MapLibreMap } from 'maplibre-gl';

const COASTLINE = 'tol_coastline';
export const SEAM_LAYER = 'world-date-line';
// Where the cut shows: the date line's sea, south of Chukotka (65° N) and
// north of the Ross Ice Shelf (78° S). Fiji's islands on the line are under
// a pixel at these zooms.
const SOUTH = -78;
const NORTH = 64;

export function hideDateLine(map: MapLibreMap): void {
  if (!map.getLayer(COASTLINE)) return;
  const water: unknown = map.getLayer('water') ? map.getPaintProperty('water', 'fill-color') : undefined;
  if (typeof water !== 'string') return;
  map.addSource(SEAM_LAYER, {
    type: 'geojson',
    data: {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'LineString',
        coordinates: [
          [180, SOUTH],
          [180, NORTH],
        ],
      },
    },
  });
  // Just above the coastline, under everything drawn on the water.
  const layers = map.getStyle().layers;
  const next = layers[layers.findIndex((l) => l.id === COASTLINE) + 1]?.id;
  map.addLayer(
    {
      id: SEAM_LAYER,
      type: 'line',
      source: SEAM_LAYER,
      maxzoom: 2,
      paint: { 'line-color': water, 'line-width': 3 },
    },
    next,
  );
}
